import { Link } from 'react-router';
import impressum from '../../../legal/impressum.md?raw';
import datenschutz from '../../../legal/datenschutz.md?raw';
import { useDocumentTitle } from '../app/context.js';
import { renderMarkdown } from '../lib/markdown.js';
import { LegalLinks } from './SignInPage.js';

const TEXTS = { impressum: { title: 'Impressum', source: impressum }, datenschutz: { title: 'Datenschutz', source: datenschutz } };

/** Öffentlich (ohne Anmeldung). Quelle: legal/*.md im Repo – dort bearbeiten. */
export function LegalPage({ doc }: { doc: keyof typeof TEXTS }) {
  const { title, source } = TEXTS[doc];
  useDocumentTitle(title);
  return (
    <div className="legal">
      <header className="legal__head">
        <Link to="/" className="wordmark" aria-label="Betriebsam – Start">
          Betriebsam
        </Link>
        <Link to="/" className="link-btn">
          ← Zurück
        </Link>
      </header>
      <article className="legal__body">{renderMarkdown(source)}</article>
      <LegalLinks />
    </div>
  );
}
